export default __webpack_public_path__ + "static/shipping-4-6e971651034e548e39073a97b70f9b12.jpg";